import * as types from '../types'
const state = {
  main_doctorPage: JSON.parse(localStorage.getItem('doctorDemo')) || {},
  main_doctorPagestate: JSON.parse(localStorage.getItem('main_doctorPagestate')) || false
}
const actions = {
  set_doctorPage({commit, state}, res) {
    localStorage.setItem('doctorDemo',res);
    commit(types.SET_DOCTORPAGE_SET, res);
    commit(types.SET_DOCTORPAGE_SET_STATE, true);
    localStorage.setItem('main_doctorPagestate', true);
  },
  del_doctorPage({commit, state}, res) {
    localStorage.removeItem(res);
    commit(types.SET_DOCTORPAGE_SET, res);
    commit(types.SET_DOCTORPAGE_SET_STATE, false);
    localStorage.setItem(res, false);
  }

}
const getters = {
  main_doctorPage: state => state.main_doctorPage,
  main_doctorPagestate: state => state.main_doctorPagestate
}

const mutations = {
  [types.SET_DOCTORPAGE_SET](state, res) {
    state.main_doctorPage = res
  },
  [types.SET_DOCTORPAGE_SET_STATE](state, res) {
    state.main_doctorPagestate = res
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/doctorpage.js